import type { Dorama } from "../types";

export const categoryLabels: Record<string, string> = {
  romance: "Romance",
  action: "Ação",
  drama: "Drama",
  asian: "Asiáticos",
  hot: "Hot",
  turkish: "Turcos",
  brazilian: "Brasileiro",
  comedy: "Comédia",
  thriller: "Suspense",
  fantasy: "Fantasia",
};

export const categoryIcons: Record<string, string> = {
  romance: "💕",
  action: "⚔️",
  drama: "🎭",
  asian: "🏯",
  hot: "🔥",
  turkish: "🧿",
  brazilian: "🇧🇷",
  comedy: "😄",
  thriller: "🕵️",
  fantasy: "✨",
};

export function formatPrice(price: number | null) {
  return (price ?? 4.99).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function isDoramaFree(freeUntil: string | null | undefined) {
  if (!freeUntil) return false;
  const end = new Date(freeUntil).getTime();
  return Number.isFinite(end) && end > Date.now();
}

const catalogViewLabels: Record<string, string> = {
  "Respirar": "630K",
  "Flechaço Entre Luz e Escuridão": "129K",
  "Refugio Perigoso": "775K",
  "Reinvindicada Pelo Irmão Alfa do Meu Ex": "210K",
  "Superando Meu Guarda Costas": "154K",
  "Paixão Tabu Meu Meio-Irmão": "160K",
  "Herói Deve Nunca Rebaixar-se": "766K",
  "Caçador no Ringue: Punhos de Justiça": "816K",
  "Sniper Americano: A Última Rodada": "344K",
  "O Bilionário e a Amada Grávida Desaparecida": "445K",
  "O Jogo da Criada Astuta": "23,3K",
  "O Segredo do Anjo": "300K",
  "Desejo do Meu Alfa Acidental": "357K",
  "Tive um Bebê sem você": "176K",
  "Encontro do Destino": "403K",
  "Implorando Sua Esposa Herdeira Secreta": "508K",
  "A JORNADA DE UM HERDEIRO!": "716K",
  "Anos 80: A Grande mudança da esposa Gordinha": "595K",
  "Sem Ela o Meu Mundo Desaba": "353K",
  "Sua Doce Bela": "479K",
  "O Homem que Estava ao Teu lado": "324K",
  "O Garoto do Programa Que Conheci em Paris": "852K",
  "De Repente Casados": "404K",
  "Minhas Versões de Amor": "159K",
  "Cinderela e o Segredo do Pobre Milinário": "88,0K",
  "A Vingança do Genro": "435K",
  "Troca de Noivos. O CEO indeciso e o Bilionário Secreto": "193K",
};

export function formatViews(dorama: Pick<Dorama, "id" | "title" | "views">) {
  const catalogLabel = catalogViewLabels[dorama.title];
  if (catalogLabel) return catalogLabel;

  const provided = Number(dorama.views);
  if (Number.isFinite(provided) && provided > 0) {
    return new Intl.NumberFormat("pt-BR", { notation: "compact", maximumFractionDigits: 1 }).format(provided);
  }

  let hash = 0;
  for (const character of dorama.id) hash = ((hash << 5) - hash + character.charCodeAt(0)) | 0;
  const generated = 12_000 + Math.abs(hash) % (890_000 - 12_000);
  if (generated >= 1_000_000) {
    const millions = generated / 1_000_000;
    return `${millions.toFixed(millions >= 10 ? 0 : 1).replace(".", ",")}M`;
  }
  if (generated >= 1_000) {
    const thousands = generated / 1_000;
    return `${thousands.toFixed(thousands >= 100 ? 0 : 1).replace(".", ",")}K`;
  }
  return String(generated);
}

export function categoryName(category: string | null) {
  return categoryLabels[category || ""] || category || "Dorama";
}
